export const ru = {
    'button-text': 'Все объявления с видеодополнениями'
};
